import { Beer, Zap, Coffee, Ship, ArrowUpRight } from "lucide-react";
import { INDUSTRIES } from "../../lib/site-content";
import { Reveal, StaggerGroup, StaggerItem } from "./Reveal";

const ICONS = { Beer, Zap, Coffee, Ship };

export const Industries = () => {
  return (
    <section
      id="doelgroepen"
      data-testid="industries-section"
      className="relative bg-white py-24 lg:py-32"
    >
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <Reveal className="max-w-2xl">
          <p className="mb-4 text-xs font-bold uppercase tracking-[0.2em] text-slate-500">
            Sectoren
          </p>
          <h2 className="font-display text-3xl font-bold tracking-tight text-[#0F172A] sm:text-4xl lg:text-5xl">
            Accijns-expertise voor elke schakel in uw keten
          </h2>
          <p className="mt-5 text-lg text-slate-600">
            Van producent tot logistieke dienstverlener — wij vertalen de
            Belgische accijnswetgeving naar een concrete, werkbare flow voor uw
            sector.
          </p>
        </Reveal>

        <StaggerGroup className="mt-14 grid grid-cols-1 gap-6 lg:grid-cols-12">
          {INDUSTRIES.map((ind) => {
            const Icon = ICONS[ind.icon];
            return (
              <StaggerItem key={ind.id} className={ind.span}>
                <article
                  data-testid={`industry-card-${ind.id}`}
                  className="group relative h-full min-h-[340px] overflow-hidden rounded-3xl border border-slate-200 shadow-[0_8px_30px_rgba(15,23,42,0.05)]"
                >
                  <img
                    src={ind.image}
                    alt={ind.title}
                    className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0F172A] via-[#0F172A]/70 to-[#0F172A]/10" />
                  <div className="relative flex h-full flex-col justify-between p-7">
                    <div className="flex items-center justify-between">
                      <span className="grid h-12 w-12 place-items-center rounded-2xl bg-white/10 text-white backdrop-blur-md ring-1 ring-white/20">
                        <Icon className="h-6 w-6" strokeWidth={2} />
                      </span>
                      <span className="grid h-10 w-10 translate-y-1 place-items-center rounded-full bg-[#F59E0B] text-[#0F172A] opacity-0 transition-all duration-300 group-hover:translate-y-0 group-hover:opacity-100">
                        <ArrowUpRight className="h-5 w-5" />
                      </span>
                    </div>
                    <div>
                      <h3 className="font-display text-2xl font-bold leading-tight text-white">
                        {ind.title}
                      </h3>
                      <p className="mt-3 max-w-md text-sm leading-relaxed text-slate-200">
                        {ind.focus}
                      </p>
                    </div>
                  </div>
                </article>
              </StaggerItem>
            );
          })}
        </StaggerGroup>
      </div>
    </section>
  );
};
